import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import {
  activationStateResponse,
  deviceStatusResponse,
} from 'src/app/shared/constants/response-mapping';
import { Utility } from 'src/app/shared/utils/utility.service';

@Pipe({
  name: 'deviceStatusPipe',
})
export class DeviceStatusPipe implements PipeTransform {
  readonly CONSTANTS = CONSTANTS;
  readonly activationStateResponse = activationStateResponse;
  readonly deviceStatusResponse = deviceStatusResponse;
  transform(
    activationState: string,
    batteryPercentage: string,
    deviceStatus: any,
    unitName: string
  ): any {
    let battery = Utility.getBatteryPercentage(batteryPercentage);
    if (
      activationStateResponse[activationState] ===
        CONSTANTS.PENDING_ACTIVATION ||
      battery <= Number(CONSTANTS.BATTERY_ALARAM_PERCENTAGE) ||
      activationStateResponse[activationState] ===
        CONSTANTS.PENDING_DEACTIVATION
    ) {
      return CONSTANTS.LOCK_WITH_ISSUE_STATUS_ICON;
    } else if (
      activationStateResponse[activationState] === CONSTANTS.ACTIVATED &&
      deviceStatusResponse[deviceStatus] === CONSTANTS.DEVICE_IS_LOCKED &&
      battery > Number(CONSTANTS.BATTERY_ALARAM_PERCENTAGE)
    ) {
      return CONSTANTS.LOCK_STATUS_ICON;
    } else if (
      activationStateResponse[activationState] === CONSTANTS.ACTIVATED &&
      deviceStatusResponse[deviceStatus] === CONSTANTS.DEVICE_IS_UNLOCKED &&
      battery > Number(CONSTANTS.BATTERY_ALARAM_PERCENTAGE)
    ) {
      return CONSTANTS.UNLOCK_STATUS_ICON;
    } else {
      if (
        unitName &&
        activationStateResponse[activationState] === CONSTANTS.ACTIVATED
      ) {
        return CONSTANTS.LOCK_STATUS_ICON;
      } else if (unitName) {
        return CONSTANTS.DEFAULT_STATUS_ICON;
      } else {
        return CONSTANTS.ACCESS_POINT_STATUS_ICON;
      }
    }
  }
}
